//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      avatarUrl: "",
      clipped: false,
      showSearch: false,
      search: "",
      drawer: false,
      fixed: false,
      categories: [],
      courses: [],
      fetched: false,
      pictureCheck: false,
      initials: "",
      loggedIn: false,
      isTeacher: false,
      user: {
        firstName: "",
        lastName: "",
        personId: ""
      },
      miniVariant: false,
      title: "USTP Showreel"
    };
  },
  created() {
    if (this.$route.name === "search-search") {
      this.search = this.$route.query.term;
    }
    if (Cookies.get("userId")) this.fetchInitialAvatar();
    this.fetchTags();
    if (Cookies.get("userId")) this.getUser();
    this.getLVs();

    this.$nuxt.$on("changeUpperTerm", (query) => {
      this.search = query;
    });

    this.$nuxt.$on("eraseSearch", () => (this.search = ""));
  },
  methods: {
    fetchInitialAvatar() {
      axios
        .get("/api/showreel-backend/public/api/user/profile", {
          params: { personId: Cookies.get("personId") }
        })
        .then((res) => {
          if (res.data.profile.profilePicture) {
            this.avatarUrl =
              "/api/showreel-backend/public/images/profilePicturesThumbnails/" +
              res.data.profile.profilePicture;
          } else {
            this.avatarUrl = "";
          }
          let name =
            res.data.profile.firstName + " " + res.data.profile.lastName;
          this.initials = name
            .split(" ")
            .map(function(item) {
              return item[0];
            })
            .join("");
          this.pictureCheck = res.data.permissions.find(
            (i) => i.permissionId === 2
          )
            ? true
            : false;
          this.isTeacher = res.data.profile.teacherId ? true : false;
          if (this.isTeacher) {
            this.pictureCheck = true;
          }
          this.fetched = true;
        })
        .catch((err) => {
          console.log(err);
          this.fetched = false;
        });
    },
    onSearch(value) {
      this.showSearch = value;
    },
    getUser() {
      this.loggedIn = true;
      this.user.firstName = Cookies.get("userFirstName");
      this.user.lastName = Cookies.get("userLastName");
      this.user.personId = Cookies.get("personId");
    },
    fetchTags() {
      axios({
        method: "get",
        url: "/api/showreel-backend/public/api/tags",
        params: {
          isCategory: 1,
          page: 0
        }
      })
        .then((response) => {
          this.categories = [...response.data.results];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLVs() {
      axios({
        method: "get",
        url: "/api/showreel-backend/public/api/degreeprograms"
      })
        .then((response) => {
          this.courses = response.data.filter(
            (el) => el.title != "Forschungsprojekte"
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDevice() {
      return window.innerWidth < 1264;
    },
    startSearch() {
      if (this.search !== null && this.search !== "") {
        if (this.$route.name === "search-search") {
          this.$nuxt.$emit("search", this.search);
        } else {
          this.$router.push("/search?term=" + this.search);
        }
        this.$nuxt.$emit("refreshTerm", this.search);
      }
    },
    async logout() {
      axios({
        method: "post",
        url: "/api/showreel-backend/public/api/logout"
      })
        .then((response) => {
          Cookies.remove("userId");
          Cookies.remove("userFirstName");
          Cookies.remove("userLastName");
          Cookies.remove("role");
          Cookies.remove("personId");
          Cookies.remove("isAdmin");
          localStorage.removeItem('user');
          this.loggedIn = false;
          this.user.firstName = "";
          this.user.lastName = "";
          this.drawer = false;
          this.$router.push("/");
        })
        .catch((err) => {
          console.log("Error");
        });
    }
  },
  watch: {
    $route() {
      if (this.$route.name !== "search-search") {
        this.$nuxt.$emit("eraseSearch");
      }
    },
    showSearch(val) {
      let bar = document.getElementById("searchBar");
      if (val) {
        bar.animate([{ height: "0px" }, { height: "64px" }], {
          duration: 200,
          iterations: 1,
          easing: "ease-in-out"
        });
        bar.style.height = "64px";
      } else {
        bar.animate([{ height: "64px" }, { height: "0px" }], {
          duration: 200,
          iterations: 1,
          easing: "ease-in-out"
        });
        bar.style.height = "0px";
      }
    }
  }
};
